<button
  class="btn"
  title="{{title | translate}}"
  [ngClass]="buttonClasses"
  [type]="type"
  [disabled]="disabled"
  [id]="buttonId"
  [tabindex]="tabIndex"
  (click)="onClick($event)">
  <pcs-icon *ngIf="icon" icon="{{icon}}" [styles]="iconStyles"></pcs-icon>
  <span *ngIf="buttonText">{{buttonText | translate}}</span>
</button>
